import { createBehavior } from '@area17/a17-behaviors';

const PATTERN_WIDTH = 98;
const PATTERN_HEIGHT = 147;

const pattern = createBehavior(
  'pattern',
  {
    updateRowCountFromCss() {
      // Columns
      this.cols = null;
      const colVar = getComputedStyle(this.$node).getPropertyValue(
        '--pattern-cols'
      );
      if (colVar) {
        this.cols = parseInt(colVar, 10);
      }

      // Rows
      this.rows = parseInt(
        getComputedStyle(this.$node).getPropertyValue('--pattern-rows') ?? 1,
        10
      );
    },
    updateWidth() {
      this.width = this.$sensor.getBoundingClientRect().width;
    },
    handleWindowResize() {
      this.updateRowCountFromCss();
      this.updateWidth();
      this.render();
    },
    render() {
      const colCount =
        this.cols ?? Math.max(5, Math.floor(this.width / PATTERN_WIDTH));
      const colSize = `${100 / colCount}%`;
      const height = this.rows * PATTERN_HEIGHT;
      const width = colCount * PATTERN_WIDTH;
      const paddingHeight = `${(height / width) * 100}%`;
      this.$node.style.setProperty('background-size', `${colSize} auto`);
      this.$node.style.setProperty('padding-top', paddingHeight);
    },
  },
  {
    init() {
      this.$sensor = this.getChild('sensor');
      window.addEventListener('resize', this.handleWindowResize);
      this.observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          this.width = parseInt(entry.contentRect.width, 10);
          this.render();
        }
      });
      this.observer.observe(this.$sensor);

      this.updateRowCountFromCss();
      this.updateWidth();
      this.render();
    },
    destroy() {
      window.removeEventListener('resize', this.handleWindowResize);
      this.observer.unobserve(this.$sensor);
    },
  }
);

export default pattern;
